module.exports = __webpack_public_path__ + "img/DW365-101.f0a241cd.jpg";